<template>
  <div class="filters-controls" :class="bem('filters-controls', { appearance })">
    <BasicButton
      v-if="!visitor.isGuest && $listeners.save"
      appearance="pseudo-link"
      @click="$emit('save')"
    >Сохранить фильтры</BasicButton>
    <BasicButton
      :appearance="noDashedReset ? 'muted' : 'pseudo-link-muted'"
      size="l"
      @click="$emit('reset')"
    >Сбросить</BasicButton>
  </div>
</template>

<script>
  import { bem } from 'src/utils/bem.js';

  import BasicButton from 'src/components/BasicButton/BasicButton.vue';

  export default {
    name: 'FiltersControls',
    components: { BasicButton },
    inject: ['visitor'],
    props: {
      appearance: String,
      noDashedReset: Boolean,
    },
    methods: {
      bem,
    },
  }
</script>